/**
 * Static role-code -> sidebar-group mapping for the permission matrix screen.
 *
 * The real `Role` model (see `@ooh/contracts`) has no group/tier column —
 * this is a frontend-only construct until the backend gains one. Mirrors
 * `apps/mockups/src/data/permissions.ts`'s `roleGroups` export exactly.
 *
 * TODO: Move to @ooh/contracts once Role model gains a group/tier column.
 */

/** Literal union of admin.json keys so `t(labelKey)` typechecks against the i18next resource types. */
export type RoleGroupLabelKey =
  | 'permissionMatrix.roleGroups.system'
  | 'permissionMatrix.roleGroups.deptAdmins'
  | 'permissionMatrix.roleGroups.managers'
  | 'permissionMatrix.roleGroups.staff';

export interface RoleGroupDef {
  id: string;
  /** i18n key for the translated group label. */
  labelKey: RoleGroupLabelKey;
  roleCodes: string[];
}

export const ROLE_GROUPS: RoleGroupDef[] = [
  {
    id: 'system',
    labelKey: 'permissionMatrix.roleGroups.system',
    roleCodes: ['admin', 'business_owner', 'business_admin', 'sales_director', 'administracja'],
  },
  {
    id: 'dept-admins',
    labelKey: 'permissionMatrix.roleGroups.deptAdmins',
    roleCodes: [
      'admin_sprzedazy',
      'admin_konstrukcji',
      'admin_billboardow',
      'admin_citylightow',
      'admin_finansow',
    ],
  },
  {
    id: 'managers',
    labelKey: 'permissionMatrix.roleGroups.managers',
    roleCodes: [
      'manager_media_plannerow',
      'manager_nowych_produktow',
      'manager_pozysku',
      'manager_realizacji',
    ],
  },
  {
    id: 'staff',
    labelKey: 'permissionMatrix.roleGroups.staff',
    roleCodes: [
      'sales',
      'planner',
      'finance',
      'new_products',
      'account_beginner',
      'nowe_produkty_beginner',
      'pozysk',
      'realizacja',
    ],
  },
];
